import {auth} from "../../../firebaseConfig";
import {sendPasswordResetEmail} from "firebase/auth";

export const sendPasswordResetEmailToUser = async(email: string) => {
  await sendPasswordResetEmail(auth, email);
};
